// eslint-disable-next-line no-restricted-imports -- the surface.strong values, until flat-ui ships the neutral intent (ST-5045)
import { flatUiThemeOptions, grey } from "@flat-ui";
import { createTheme, deepmerge } from "@mui-wrapper";
import { textfieldSx } from "@styles/common-styles";

/** Theme mode type for the application */

/**
 * The one neutral surface layer the flat-ui palette has no slot for yet.
 *
 * `subtle` and `muted` used to live here too; they are flat-ui's `surfaces.secondary` and
 * `surfaces.tertiary` now. `strong` has no `surfaces/*` counterpart - Figma's closest token is
 * `neutral/main`, which is grey[200] light and grey[800] dark, exactly these values.
 *
 * TODO: point `strong` at `neutral.main` and delete this augmentation once flat-ui ships the
 * `neutral` intent (ST-5045): https://faro01.atlassian.net/browse/ST-4922
 */

/* Custom theme options for the dashboard that are different than the LOTV package */
const dashboardThemeOptions = {
  // The top-level palette is the light colour scheme; `colorSchemes.dark` below is merged over
  // flat-ui's own dark scheme.
  palette: {
    surface: {
      strong: grey[200]
    }
  },
  colorSchemes: {
    dark: {
      palette: {
        surface: {
          strong: grey[800]
        }
      }
    }
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: ({
          theme
        }) => theme.unstable_sx({
          ...textfieldSx
        })
      }
    }
  }
};

/** Creates a combined theme options with the flat-ui theme options and the dashboard specific theme options */
export const combinedThemeOptions = deepmerge(flatUiThemeOptions, dashboardThemeOptions);

/**
 * The dashboard theme: the flat-ui theme plus the dashboard's own overrides.
 *
 * Light and dark are two colour schemes of this one theme, both coming from flat-ui, so there is
 * a single theme object rather than one per mode. `DynamicThemeProvider` picks the scheme; see
 * the note there for why a `palette.mode` cannot do it any more.
 */
export const dashboardTheme = createTheme(combinedThemeOptions);